export const showroom = {
  section04: {
    item_01: {
      title: "Our Range",
      content:
        "Browse our range of blinds, curtains and shutters and order free samples before you move in"
    },
    item_02: {
      title: "Appointments",
      content:
        "Appointments available from the day you get your keys"
    },
    item_03: {
      title: "Many Options",
      content:
        "Options for every budget, including blackout, thermal and privacy solutions"
    },
    item_04: {
      title: "Flexible Appointments",
      content:
        "Flexible appointments to suit you, including evenings and weekends"
    },
    item_05: {
      title: "Multi-blind Discount",
      content:
        "Our multi-blind discount will help your budget go further"
    },
    item_06: {
      title: "Expert Measuring",
      content:
        "Get it right the first time with expert measuring and fitting"
    }
  }
};
